import { Button, Divider, Flex, Table } from 'antd'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useQuestionnairesServiceGetQuestionnaireListEndpoint } from 'src/api/queries'
import { QuestionnaireState } from 'src/api/requests'
import { SearchBar, Select } from 'src/components'
import { useConfig } from 'src/features/questionnaires/hooks'
import { useDefaultSortingItem, useTablePagination } from 'src/hooks'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'
import { resetPagination } from 'src/utils'

export const QuestionnairesTable = () => {
  const { t } = useLocales()
  const pagination = useTablePagination()

  const [search, setSearch] = useState('')
  const [status, setStatus] = useState<QuestionnaireState>()

  const { defaultSortingOption } = useDefaultSortingItem()

  const { columns } = useConfig()
  const navigate = useNavigate()

  const queryParams = {
    pageNumber: Number(pagination.current),
    pageSize: Number(pagination.pageSize),
    ...(!!search && {
      searchTerm: search
    }),
    ...(!!status && {
      states: [status]
    })
  }
  const { data, isLoading } =
    useQuestionnairesServiceGetQuestionnaireListEndpoint(queryParams)

  const statusOptions = Object.values(QuestionnaireState).map((item) => ({
    label: t(`questionnaires.${item}`),
    value: item
  }))

  const options = [defaultSortingOption, ...statusOptions]

  const onSearch = (val: string) => {
    setSearch(val)
    resetPagination(pagination)
  }

  const onCategorySelect = (val: QuestionnaireState) => {
    setStatus(val)
    resetPagination(pagination)
  }

  return (
    <Flex vertical>
      <Flex justify="space-between">
        <SearchBar
          onSearch={onSearch}
          placeholder={t('questionnaires.search_by_title')}
        />

        <Flex gap={8}>
          <Select
            options={options}
            onChange={(category: QuestionnaireState) =>
              onCategorySelect(category)
            }
          />

          <Button
            type="primary"
            onClick={() => navigate(paths.questionnaires.create)}
          >
            {t('questionnaires.create_new_questionnaire')}
          </Button>
        </Flex>
      </Flex>

      <Divider />

      <Table
        bordered
        rowKey="id"
        dataSource={data?.data}
        columns={columns}
        loading={isLoading}
        scroll={{ x: 'max-content' }}
        pagination={{
          ...pagination,
          total: data?.totalCount
        }}
      />
    </Flex>
  )
}
